import Page7 from '../../features/ServiciosUXUI/Page7';

export default function ServiciosUXUI() {
  return (
    <>
      <Page7></Page7>
    </>
  );
}
